/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contactbusinessexamplecom1Inputs */

const en_contactbusinessexamplecom1 = /** @type {(inputs: Contactbusinessexamplecom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contact@business.com`)
};

const de_contactbusinessexamplecom1 = /** @type {(inputs: Contactbusinessexamplecom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`contact@business.com`)
};

/**
* | output |
* | --- |
* | "contact@business.com" |
*
* @param {Contactbusinessexamplecom1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const contactbusinessexamplecom1 = /** @type {((inputs?: Contactbusinessexamplecom1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contactbusinessexamplecom1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contactbusinessexamplecom1(inputs)
	return de_contactbusinessexamplecom1(inputs)
});
export { contactbusinessexamplecom1 as "contactBusinessexamplecom" }